mobileSize = 1100;
function ticketMain() {
  if ($('body').hasClass('saffireMobileSize')) {
      $('.ticket').insertAfter('.header-right');
  } else {
      $('.ticket').appendTo('.outer-ticket');
  }
}
function buttonfeature(){
  const e = $(".featureLineupContainer");
  e.length > 0 &&
      e.each((e, t) => {
          const i = $(t).find(".featureLineup-more"),
              n = $(t).find(".featureLineup-text"),
              a = n.text();
          n.html(`<span class="featureLineup-text-content">${a}</span>`), i.appendTo(n);
      });

}
$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1100) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1101) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
  ticketMain();
  buttonfeature();
});

$(window).load(function(){
  $('body').addClass('pageIsLoaded');
  ticketMain();
});
$(window).resize(function () {
  ticketMain();
});